import React from "react";
import logger from "logger";

import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import CardContent from "@material-ui/core/CardContent";
import { ItemsWon } from "./ItemsWon";
import { StringValue } from "./StringValue";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Wheel Spin">
      <CardContent>
        <AccountDetailsSection
          task={task}
          showOwner={props.showOwner}
          showUser={props.showUser}
        />
        <StringValue
          label={"Token Used"}
          value={task.taskstatusdetail.tokenused}
        />
        <StringValue
          label={"Spin Status"}
          value={task.taskstatusdetail.spinstatus}
        />
        <StatusSection task={task} />
        <StringValue
          label={"Wheel End Time:"}
          value={task.taskstatusdetail.endtime}
        />
        <ItemsWon task={task} label={"Items Won:"} />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
